export enum MatchingResponseTypeEnum {
  ACCEPTED, //수락
}

export const MatchingResponseTypeTextEnum: Record<MatchingResponseType, string> = {
  ACCEPTED: '수락 완료', //수락
};

export type MatchingResponseType = keyof typeof MatchingResponseTypeEnum;
